import { GlobalAxios } from "../axios/axios-config";
import { IDonor, IGetDonor, IUpdateDonor } from "../models/donor";

const DONOR_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Donor/";

export const createDonor = (item: IDonor) => {
  return GlobalAxios.post(DONOR_ROUTE, item);
};

export const getDonorById = (id: string) => {
  return GlobalAxios.get<IGetDonor>(DONOR_ROUTE + id);
};

export const updateDonorById = ({
  item,
  id,
}: {
  item: IUpdateDonor;
  id: string;
}) => {
  return GlobalAxios.put(DONOR_ROUTE + id, item);
};

export const deleteItemById = (id: string) => {
  return GlobalAxios.delete(DONOR_ROUTE + id);
};
